import { CreditDocuments } from '@interhyp/module-documents';
import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { Navigation, NavItems } from '../../navigation/Navigation';
import '@interhyp/module-documents/esm/index.css';

export interface InquiryDocumentsWrapperProps {
  providerId: string;
}

export function InquiryDocumentsWrapper({ providerId }: InquiryDocumentsWrapperProps): JSX.Element {
  const { inquiryId } = useParams<{ inquiryId: string }>();
  const navigationItems: NavItems = useMemo(() => {
    return [
      { to: `/credit/inquiries/${inquiryId}`, translation: 'navigation.preInquiry' },
      { to: `/credit/inquiries/${inquiryId}/documents`, translation: 'navigation.documents' },
      {
        to: `/credit/inquiries/${inquiryId}/communication`,
        translation: 'navigation.communication',
      },
    ];
  }, [inquiryId]);

  return (
    <>
      <Navigation navItems={navigationItems} />
      <CreditDocuments preInquiryId={inquiryId} providerId={providerId} />
    </>
  );
}
